module.exports = __webpack_public_path__ + "assets/6238d62d59e02c52ea3a6b816e9cb410.mp3";